import { AsyncPipe, NgFor } from '@angular/common';
import { Component, inject, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RejectReason } from 'app/services/reject-reason';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const INTRO_KEY = 'rejection.intro';
const OUTRO_KEY = 'rejection.outro';

@Component({
	selector: 'app-rejection-description',
	templateUrl: './rejection-description.component.html',
	imports: [AsyncPipe, NgFor],
})
export class RejectionDescriptionComponent implements OnChanges {
	@Input() rejectReason: RejectReason;
	/**
	 * Shown on its own when neither the active locale nor the app's fallback language has `rejection`
	 * copy: a key missing from both comes back as the key itself, which fi would otherwise render.
	 */
	@Input() fallbackKey: string;

	paragraphs$: Observable<string[]>;

	private readonly translate = inject(TranslateService);

	ngOnChanges(): void {
		const reasonKey = this.rejectReason ? `rejection.reason.${this.rejectReason}` : null;
		const keys = [INTRO_KEY, OUTRO_KEY, reasonKey, this.fallbackKey].filter(Boolean);

		this.paragraphs$ = this.translate.stream(keys).pipe(
			map((translations: Record<string, string>) => {
				const translated = (key: string | null) => (key && translations[key] !== key ? translations[key] : null);
				const intro = translated(INTRO_KEY);
				const outro = translated(OUTRO_KEY);
				if (!intro || !outro) {
					return this.fallbackKey ? [translations[this.fallbackKey]] : [];
				}
				const reason = translated(reasonKey);
				return reason ? [`${intro} ${reason}`, outro] : [`${intro} ${outro}`];
			})
		);
	}
}
